module.exports = __webpack_public_path__ + "media/images/app/homepage/hero-71ffd8038abaf6e75af8cff8c72bb077.webp";